// extracted by mini-css-extract-plugin
module.exports = {"container":"HQvkBB","countdown":"_2A7ooY","textContainer":"_1rbcml"};